import { logAppHostUserAction } from './logAppHostUserAction';
export const logAppHostHeaderClickEvent = (actionResult, appId, eventType, actionTarget, elementId) => {
    logAppHostUserAction(actionResult, actionTarget, "MOS_App_Host_Header_Click" /* KnownFeatureInstrumentationEvents.MOSAppHostHeaderClick */, `${eventType}_${elementId}`, 'Click', 'MOSAppHostHeader', appId);
};
//# sourceMappingURL=logAppHostHeaderClickEvent.js.map